import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";

import { Urls } from "../../../utils/constant";

import { size, debounce } from "lodash";

import { minWidth } from "@mui/system";
import { useApi } from "../apiCall/useApi";

import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
import { setLabList } from "../../reducers/Lab/lab.reducer";

const COLUMN_LIST = [
  // { field: "customer_id", headerName: "ID", hide: true },
  {
    field: "sr_no",
    headerName: "sr. no.",
    flex: 1,
  },
  {
    field: "test_name",
    headerName: "Test Name",
    flex: 2,
  },
  {
    field: "price",
    headerName: "Price",
    flex: 2,
  },
  {
    field: "details",
    headerName: "Details",
    flex: 2,
  },

  {
    field: "status_val",
    headerName: "Status",
    flex: 1,
  },
];

const StatusList = [
  { id: 1, label: "active" },
  { id: 2, label: "In-Active" },
];

export default function useLab() {
  const dispatch = useDispatch();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [TestName, setTestName] = useState("");
  const [status, setStatus] = useState(1);

  const fetchLabList = useCallback(
    async ({ current_page = 1, row_count }) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());
        const StatusVal = status === "All" ? 0 : status;

        const { data } = await apiPost({
          url: Urls.labGet(),
          data: {
            test_name: TestName,
            status: StatusVal,
            page_size: row_count,
            current_page: current_page,
          },
        });
        // setting list to reducer
        dispatch(setLabList(data));
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
      }
    },
    [loading, status, TestName]
  );

  const handleNameChange = useCallback((e) => {
    setTestName(e.target.value);
  }, []);

  const handleStatusChange = useCallback((e) => {
    setStatus(e.target.value);
  }, []);

  return {
    gridHeaders: COLUMN_LIST,
    loading,
    loader,
    status,
    StatusList,
    TestName,
    handleNameChange,
    handleStatusChange,
    fetchLabList,
  };
}
